import * as React from 'react';
import cx from 'classnames';
import { PriceType } from '@rome/response/transact/PriceType';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import NumbersAnimator from 'components/NumbersAnimator/NumbersAnimator';
import FormattedMessage from 'components/FormattedMessage/FormattedMessage';
import ImageValueWidget from 'components/ImageValueWidget/ImageValueWidget';
import { numFormat } from 'utils/numFormat';
import InfoTooltip from './InfoTooltip';
import styles from './PriceLineItem.css';
export var OfferSymbol;
(function (OfferSymbol) {
    OfferSymbol["Minus"] = "\u2212";
})(OfferSymbol || (OfferSymbol = {}));
export const FREE_OFFER = <StringWidget strKey="free" className={cx(styles['green'], styles['allcaps'])}/>;
const DEFAULT_GRAND_TOTAL_MSG = stringTemplate('cartSummaryGrandTotal');
// TODO: This was copied over from the old SummaryPrice construct. This
// requires a bit of cleanup
export class PriceLineItem extends React.PureComponent {
    render() {
        let { text, label, subLabel, value, prefix = '', valueClassName, alwaysShow = false, priceType, priceNoteDetail, containerClassName, info, icon } = this.props;
        let finalValue;
        switch (typeof value) {
            case 'object':
                if (value === null && !alwaysShow) {
                    return null;
                }
                finalValue = value;
                break;
            case 'number':
                if (isNaN(value))
                    return null;
            case 'string': // tslint:disable-line:no-switch-case-fall-through
                const convertedValue = Number(value);
                if (convertedValue === 0 && !alwaysShow)
                    return null;
                // if the convertedValue is not a number, then it might be a valid
                // string like "FREE" or something. When converting a
                // non-stringified number using the Number() constructor, it
                // results in NaN, so this check works.
                /** In Cart V4 we are getting priceType as reverse for negetive values */
                if (priceType === PriceType.REVERSE || priceType === PriceType.DISCOUNT) {
                    prefix = OfferSymbol.Minus;
                    valueClassName = styles['green'];
                }
                finalValue = isNaN(convertedValue) ? value : `${prefix} ₹${numFormat(convertedValue)}`;
                break;
            default:
                return null;
        }
        const noteDescriptionText = (priceNoteDetail && priceNoteDetail.shortDescription) || '';
        // TODO: Check for finalValue being a component. If it is so, remove the extra <span> tag
        return (<div className={cx(styles['summary-price'], containerClassName)}>
				<div className={styles['text']}>
					<div className={styles['label-container']}>
						{icon ? (<div className={styles['offer-icon']}>
								<ImageValueWidget image={icon}/>
							</div>) : null}
						{label || text}
						{noteDescriptionText && <span> {noteDescriptionText}</span>}
						{info ? <InfoTooltip info={info} label={label}/> : null}
					</div>
					{subLabel && <div className={styles['sub-label']}>{subLabel}</div>}
				</div>
				{valueClassName ? <div className={valueClassName}>{finalValue}</div> : <span>{finalValue}</span>}
			</div>);
    }
}
export class LoadingPriceLineItem extends React.PureComponent {
    render() {
        return (<div className={cx(styles['summary-price'], styles['loading-summary-price'])}>
				<div className={styles['key']}/>
				<div className={styles['value']}/>
			</div>);
    }
}
export const GrandTotal = (props) => {
    const { value, label = DEFAULT_GRAND_TOTAL_MSG, style } = props;
    return (<div className={cx(styles['grand-total'], style)}>
			<PriceLineItem text={label} value={value} alwaysShow/>
		</div>);
};
export const GrandTotalv2 = (props) => {
    const { priceLineItems, hideSeparator } = props;
    const className = hideSeparator ? cx(styles['grand-total'], styles['hide-separator']) : styles['grand-total'];
    return (<div className={className}>
			{priceLineItems.map((priceLineItem, idx) => (<PriceLineItem {...priceLineItem} key={priceLineItem.id || idx} alwaysShow/>))}
		</div>);
};
export class LoadingGrandTotal extends React.PureComponent {
    render() {
        return (<div className={styles['grand-total']}>
				<LoadingPriceLineItem />
			</div>);
    }
}
export function SavingAmountLine(props) {
    const { summary } = props;
    if (!summary || !summary.savingAmount) {
        return null;
    }
    const animatedSavingAmount = (<div className={styles['total-savings-amount']}>
			₹<NumbersAnimator value={Number(summary.savingAmount)} time={0.5} fixed={0}/>
		</div>);
    return (<div className={styles['total-savings']}>
			<StringWidget className={styles['green']} strKey="cartSummaryTotalSavings" attributes={{ amount: animatedSavingAmount }}/>
		</div>);
}
export function CoinSavingsAmountLine(props) {
    const { coinSavingsMessage } = props;
    if (!coinSavingsMessage) {
        return null;
    }
    return (<FormattedMessage data={coinSavingsMessage.data} containerClass={styles['coin-savings']} imageClass={styles['coin-icon']} imageSize={12}/>);
}
